import { Controller } from '@hotwired/stimulus';
import TomSelect from 'tom-select';

export default class extends Controller {
  static values = {
    options: { type: Object, default: {} },
  };

  connect() {
    this.initializeTomSelect();
  }

  initializeTomSelect() {
    // Initialize Tom Select with default plugins and options
    const options = {
      plugins: ['remove_button'],
      render: {
        // Custom rendering for selected items (tags)
        item: (data, escape) => {
          return `<div class="bg-gold text-white rounded py-1 px-2 flex items-center">
                    <span>${escape(data.text)}</span>
                  </div>`;
        },
        // Custom rendering for dropdown options
        option: (data, escape) => {
          return `<div class="py-2 px-3 hover:bg-gold hover:text-black">
                    <span>${escape(data.text)}</span>
                  </div>`;
        },
      },
      ...this.optionsValue,
    };

    // Create the Tom Select instance
    this.tomSelect = new TomSelect(this.element, options);

    // Apply additional styles after initialization
    this.applyCustomStyles();
  }

  applyCustomStyles() {
    if (!this.tomSelect) return;

    // Get the wrapper element
    const wrapper = this.tomSelect.wrapper;

    // Additional classes for better Tailwind integration
    wrapper.classList.add('ts-custom-theme');

    // Find the dropdown and add custom classes when it's created
    this.tomSelect.on('dropdown_open', (dropdown) => {
      dropdown.classList.add('border-gold', 'shadow-lg');

      // Style the dropdown options
      const options = dropdown.querySelectorAll('.option');
      options.forEach((option) => {
        option.classList.add('transition-colors', 'duration-150');
      });
    });
  }

  disconnect() {
    // Clean up the Tom Select instance when the controller is disconnected
    if (this.tomSelect) {
      this.tomSelect.destroy();
    }
  }
}
